import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useCarContext } from "../../context/CarContext";

interface CarDetailsHeaderProps {
  lang: string;
  title: string;
}

const CarDetailsHeader: React.FC<CarDetailsHeaderProps> = ({ lang, title }) => {
  const { carId } = useParams<{ carId: string; lang: "en" | "fr" | "de" }>();
  const { cars } = useCarContext();
  const navigate = useNavigate();

  const car = cars.find((car) => car.id === parseInt(carId || "0"));

  if (!car) {
    return <p>Car not found!</p>;
  }

  return (
    <div className="car-details-header">
      <div className="back">
        <motion.button
          onClick={() => navigate(`/${lang}/cars`)}
          className="back-button"
        >
          ← {title}
        </motion.button>
      </div>
      <div>
        <h1 className="car-details-page-title">
          <strong>{car.title}</strong>
        </h1>
        <h2 className="car-details-page-subtitle">{car.subtitle}</h2>
      </div>
      <div className="car-details-page-title"></div>
    </div>
  );
};

export default CarDetailsHeader;
